import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
} from '@angular/core';

enum Tabs {
  record = 'Historial',
  comments = 'Comentarios',
  files = 'Archivos',
}
@Component({
  selector: 'app-secondary-information',
  templateUrl: './secondary-information.component.html',
  styleUrls: ['./secondary-information.component.scss'],
})
export class SecondaryInformationComponent implements OnInit {
  public Tabs = Tabs;

  @Input() view: boolean = false;
  @Output() hidden = new EventEmitter<boolean>();

  selected: Tabs = Tabs.record;

  constructor() {}

  ngOnChanges() {
    if (this.view) {
      console.log('buscar data');
    }
  }

  ngOnInit(): void {}

  clickHidden() {
    this.hidden.emit(false);
  }
}
